import { buildLeadWhatsAppUrl } from "@/lib/lead-whatsapp";

export type PlatformLeadPayload = {
  nombre: string;
  negocio: string;
  email: string;
  telefono: string;
  planInteresado?: string;
  rubro?: string;
};

/**
 * Captura lead de plataforma (self-service OFF).
 * Un solo contrato POST /api/leads + WhatsApp de ventas.
 */
export async function submitPlatformLead(
  payload: PlatformLeadPayload,
  opts?: { openWhatsApp?: boolean },
): Promise<{ id: string; waUrl: string }> {
  const res = await fetch("/api/leads", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const data = (await res.json().catch(() => ({}))) as { error?: string };
    throw new Error(data.error ?? "No se pudo enviar la solicitud");
  }
  const data = (await res.json()) as { id: string };
  const waUrl = buildLeadWhatsAppUrl(payload);
  if (opts?.openWhatsApp !== false) {
    window.open(waUrl, "_blank", "noopener,noreferrer");
  }
  return { id: data.id, waUrl };
}
